import type { ConditionTypeType } from '@/types/domain/childNotebook/valueObjects/conditionType';

import { PrimitiveValueObject } from '@/domain/primitiveValueObject';

/**
 * 体調
 */
export class ConditionType extends PrimitiveValueObject<ConditionTypeType> {
  static create(value: ConditionTypeType): ConditionType {
    return new ConditionType(value);
  }
}
